var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-modal",
    {
      attrs: {
        "content-css": {
          minWidth: _vm.getMinWidth,
          maxWidth: _vm.getMaxWidth,
          minHeight: "90vh"
        }
      },
      on: {
        hide: function($event) {
          return _vm.hideCertificate()
        }
      },
      model: {
        value: _vm.show_modal,
        callback: function($$v) {
          _vm.show_modal = $$v
        },
        expression: "show_modal"
      }
    },
    [
      _c(
        "q-modal-layout",
        [
          _c(
            "q-toolbar",
            { attrs: { slot: "header" }, slot: "header" },
            [
              _c("q-btn", {
                attrs: { flat: "", round: "", dense: "", icon: "fas fa-times" },
                on: {
                  click: function($event) {
                    return _vm.hideCertificate()
                  }
                }
              }),
              _c("q-toolbar-title", [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("certificate")) +
                    "\n            "
                )
              ])
            ],
            1
          ),
          _c("div", { staticClass: "layout-padding" }, [
            _c("div", { staticClass: "flex justify-around q-mb-sm" }, [
              _vm.show_modal && _vm.site_url && _vm.certificate
                ? _c(
                    "div",
                    { class: _vm.$q.platform.is.mobile ? "q-mb-sm" : "" },
                    [
                      _c("social-sharing", {
                        attrs: {
                          url: _vm.site_url,
                          title:
                            _vm.full_name +
                            " " +
                            _vm.$t("got_a_certificate_on_the_training") +
                            " " +
                            _vm.certificate.webcast_title,
                          description:
                            _vm.full_name +
                            " " +
                            _vm.$t("got_a_certificate_on_the_training") +
                            " " +
                            _vm.certificate.webcast_title,
                          quote:
                            _vm.full_name +
                            " " +
                            _vm.$t("got_a_certificate_on_the_training") +
                            " " +
                            _vm.certificate.webcast_title,
                          networks: _vm.overriddenNetworks
                        },
                        inlineTemplate: {
                          render: function() {
                            var _vm = this
                            var _h = _vm.$createElement
                            var _c = _vm._self._c || _h
                            return _c(
                              "div",
                              { staticClass: "flex" },
                              [
                                _c(
                                  "network",
                                  {
                                    staticClass: "q-mr-xs",
                                    attrs: {
                                      network: "facebook",
                                      id: "facebook"
                                    }
                                  },
                                  [
                                    _c("q-btn", {
                                      attrs: {
                                        color: "secondary",
                                        icon: "fab fa-facebook-f"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "network",
                                  {
                                    staticClass: "q-mr-xs",
                                    attrs: {
                                      network: "linkedin",
                                      id: "linkedin"
                                    }
                                  },
                                  [
                                    _c("q-btn", {
                                      attrs: {
                                        color: "secondary",
                                        icon: "fab fa-linkedin-in"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "network",
                                  {
                                    staticClass: "q-mr-xs",
                                    attrs: { network: "twitter", id: "twitter" }
                                  },
                                  [
                                    _c("q-btn", {
                                      attrs: {
                                        color: "secondary",
                                        icon: "fab fa-twitter"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "network",
                                  {
                                    staticClass: "q-mr-xs",
                                    attrs: {
                                      network: "whatsapp",
                                      id: "whatsapp"
                                    }
                                  },
                                  [
                                    _c("q-btn", {
                                      attrs: {
                                        color: "secondary",
                                        icon: "fab fa-whatsapp"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          },
                          staticRenderFns: []
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              !_vm.$q.platform.is.mobile
                ? _c(
                    "div",
                    [
                      _c("q-btn", {
                        attrs: {
                          color: "secondary",
                          label: _vm.$t("print_certificate"),
                          icon: "fas fa-print"
                        },
                        on: {
                          click: function($event) {
                            return _vm.print()
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ]),
            _c(
              "div",
              {
                staticClass:
                  "print-certificate certificate text-center desktop-only"
              },
              [_c("img", { attrs: { src: _vm.data.image } })]
            ),
            _c(
              "div",
              {
                staticClass:
                  "print-certificate certificate-mobile text-center mobile-only"
              },
              [_c("img", { attrs: { src: _vm.data.image } })]
            )
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }